import type { FormField } from '../../types';
interface Props { field: FormField; value: unknown; onChange: (v: unknown) => void; error?: string; }
// Intentionally does not use FormFieldWrapper: the label must wrap the input so
// clicking anywhere on the label row toggles the checkbox (standard a11y pattern).
// The row layout comes from `.field-checkbox`; it cannot be an inline style here
// because it has to apply to the label, which is not itself a flex container.
export function CheckboxField({ field, value, onChange, error }: Props) {
  return (
    <div className="field field-checkbox">
      <label>
        <input type="checkbox" checked={!!value} onChange={e => onChange(e.target.checked)} />
        {field.label}{field.required && ' *'}
      </label>
      {error && <span className="field-error">{error}</span>}
    </div>
  );
}
